import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { HowWeSolveSection } from './components/HowWeSolveSection';
import { ProblemsSection } from './components/ProblemsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ConsultationSection } from './components/ConsultationSection';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ProblemsSection />
        <HowWeSolveSection />
        <BenefitsSection />
        <ConsultationSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
